/* ============================================================
   VN2 Motion Layer (Vegannett v2, Editorial Manufaktur)
   Portiert aus landing-pages/fresh-vegannett-v2/assets/js/main2.js,
   gescoped auf vn2-Attribute/-Klassen:
     [data-vn2-letters]   Letter-Splitter + Idle-Wobble
     [data-vn2-parallax]  rAF-gedrosseltes Scroll-Parallax (speed als Wert)
     .vn2-btn--magnetic   Magnetic-Hover fuer Buttons
     [data-vn2-jitter]    sanfter Idle-Jitter fuer Deko-Elemente
   Hard-Gate: prefers-reduced-motion deaktiviert alles.
   Ein globaler Guard (window.VN2Motion), passive Listener,
   destroy() raeumt alle Listener und Transforms wieder auf.
   ============================================================ */

(function () {
  'use strict';

  if (window.VN2Motion) return;

  var MQ_REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var MQ_FINE = window.matchMedia('(hover: hover) and (pointer: fine)');
  var teardowns = [];
  var parallaxItems = [];
  var ticking = false;
  var resizeTimer = null;

  function listen(target, type, fn, opts) {
    target.addEventListener(type, fn, opts);
    teardowns.push(function () { target.removeEventListener(type, fn, opts); });
  }

  /* ---- injected styles: letter wobble + jitter keyframes ---- */

  function injectStyles() {
    if (document.getElementById('vn2-motion-styles')) return;
    /* Kuratiert 2026-07-16: KEIN endloses Wobbeln pro Buchstabe und KEIN
       Idle-Jitter mehr. Beides erzeugte dutzende permanent animierte
       Compositor-Layer (will-change + infinite auf Riesen-Glyphen) und
       machte die Seite zaeh und unruhig. Stattdessen: eine einmalige,
       gestaffelte Entrance pro Buchstabe, danach Ruhe. */
    var css = '' +
      /* Woerter als nowrap-Wrapper, damit Buchstaben nie mitten im Wort umbrechen */
      '.vn2-word{display:inline-block;white-space:nowrap;}' +
      '.vn2-letter{display:inline-block;transform-origin:bottom center;' +
      'animation:vn2-letter-in 0.55s var(--vn2-ease-spring, cubic-bezier(0.175,0.885,0.32,1.275)) both;}' +
      '@keyframes vn2-letter-in{' +
      'from{opacity:0;transform:translateY(0.35em) rotate(2deg);}' +
      'to{opacity:1;transform:translateY(0) rotate(0);}}' +
      '@media (prefers-reduced-motion: reduce){' +
      '.vn2-letter{animation:none !important;opacity:1;}}';
    var style = document.createElement('style');
    style.id = 'vn2-motion-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* ---- (a) letter splitter + idle wobble ---- */

  function splitLetters(root) {
    root.querySelectorAll('[data-vn2-letters]').forEach(function (el) {
      if (el.querySelector('.vn2-letter')) return;
      var text = el.textContent;
      var frag = document.createDocumentFragment();
      var tokens = text.split(/(\s+)/); /* Woerter + Whitespace erhalten */
      var li = 0;
      tokens.forEach(function (token) {
        if (token === '') return;
        if (/^\s+$/.test(token)) {
          frag.appendChild(document.createTextNode(token));
          return;
        }
        var word = document.createElement('span');
        word.className = 'vn2-word';
        for (var i = 0; i < token.length; i++) {
          var span = document.createElement('span');
          span.className = 'vn2-letter';
          span.textContent = token[i];
          span.setAttribute('aria-hidden', 'true');
          span.style.animationDelay = (li * 0.028).toFixed(3) + 's';
          li++;
          word.appendChild(span);
        }
        frag.appendChild(word);
      });
      el.setAttribute('aria-label', text.trim());
      el.textContent = '';
      el.appendChild(frag);
    });
  }

  /* ---- (d) idle jitter: KURATIERT ENTFERNT (2026-07-16) ----
     Der permanente Jitter auf allen Deko-Elementen wirkte unruhig und
     kostete Compositor-Budget. Deko steht jetzt still. Die Funktion
     bleibt als No-op, damit init()-Aufrufer stabil bleiben. */

  function seedJitter() {}

  /* ---- (b) rAF-throttled parallax ---- */

  function collectParallax(root) {
    root.querySelectorAll('[data-vn2-parallax]').forEach(function (el) {
      for (var i = 0; i < parallaxItems.length; i++) {
        if (parallaxItems[i].el === el) return;
      }
      var speed = parseFloat(el.getAttribute('data-vn2-parallax'));
      if (!isFinite(speed) || speed === 0) speed = 0.15;
      parallaxItems.push({ el: el, speed: speed, top: 0, height: 0 });
    });
    measureParallax();
  }

  function measureParallax() {
    parallaxItems.forEach(function (item) {
      item.el.style.removeProperty('--vn2-par-y');
      var rect = item.el.getBoundingClientRect();
      item.top = rect.top + window.scrollY;
      item.height = rect.height;
    });
    applyParallax();
  }

  function applyParallax() {
    ticking = false;
    if (!parallaxItems.length) return;
    var vh = window.innerHeight;
    var sy = window.scrollY;
    parallaxItems.forEach(function (item) {
      var centerInView = item.top + item.height / 2 - sy;
      if (centerInView < -vh || centerInView > vh * 2) return;
      var delta = (vh / 2 - centerInView) * item.speed;
      // WHY Custom Property statt style.transform: ein Inline-transform ueberschreibt
      // die eigene Transform-Deklaration des Elements (Zentrierung, Rotation).
      // Ueber --vn2-par-y kann das CSS beides kombinieren.
      item.el.style.setProperty('--vn2-par-y', delta.toFixed(1) + 'px');
    });
  }

  function requestParallax() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(applyParallax);
    }
  }

  function onResize() {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(measureParallax, 150);
  }

  /* ---- (c) magnetic hover ---- */

  function bindMagnetic(root) {
    if (!MQ_FINE.matches) return;
    root.querySelectorAll('.vn2-btn--magnetic').forEach(function (el) {
      if (el._vn2Magnetic) return;
      el._vn2Magnetic = true;
      var onMove = function (e) {
        var r = el.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2;
        var y = e.clientY - r.top - r.height / 2;
        el.style.transform = 'translate(' + (x * 0.18).toFixed(1) + 'px, ' + (y * 0.22).toFixed(1) + 'px)';
      };
      var onLeave = function () { el.style.transform = ''; };
      listen(el, 'mousemove', onMove, { passive: true });
      listen(el, 'mouseleave', onLeave, { passive: true });
      teardowns.push(function () {
        el.style.transform = '';
        el._vn2Magnetic = false;
      });
    });
  }

  /* ---- lifecycle ---- */

  var scrollBound = false;

  function init(root) {
    if (MQ_REDUCED.matches) return;
    root = root && root.querySelectorAll ? root : document;
    injectStyles();
    splitLetters(root);
    seedJitter(root);
    collectParallax(root);
    bindMagnetic(root);
    if (!scrollBound) {
      scrollBound = true;
      listen(window, 'scroll', requestParallax, { passive: true });
      listen(window, 'resize', onResize, { passive: true });
    }
  }

  function destroy() {
    teardowns.forEach(function (fn) { fn(); });
    teardowns.length = 0;
    parallaxItems.forEach(function (item) { item.el.style.removeProperty('--vn2-par-y'); });
    parallaxItems.length = 0;
    scrollBound = false;
    ticking = false;
  }

  function onReducedChange(e) {
    if (e.matches) destroy();
    else init(document);
  }
  if (typeof MQ_REDUCED.addEventListener === 'function') {
    MQ_REDUCED.addEventListener('change', onReducedChange);
  }

  /* Shopify Theme-Editor: neu geladene Sections nachziehen */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  window.VN2Motion = { init: init, destroy: destroy };
})();
